var y = Object.defineProperty;
var g = (e, t, i) => t in e ? y(e, t, { enumerable: !0, configurable: !0, writable: !0, value: i }) : e[t] = i;
var c = (e, t, i) => g(e, typeof t != "symbol" ? t + "" : t, i);
function l(e) {
  if (!e)
    return console.warn("Cannot parse empty json inside parseImage"), {};
  const t = {};
  return e.id && (t.id = e.id), e.url && (t.url = e.url), e.width && (t.width = e.width), e.height && (t.height = e.height), t;
}
function C(e) {
  if (!e)
    return console.warn("Cannot parse empty json inside parseReference"), {};
  const t = {};
  return e.id && (t.id = e.id), e.fields && (t.fields = e.fields), t;
}
function f(e) {
  if (!e)
    return console.warn("Cannot parse empty json inside parseMetafield"), {};
  const t = {};
  return e.id && (t.id = e.id), e.key && (t.key = e.key), e.namespace && (t.namespace = e.namespace), e.value && (t.value = e.value), e.reference && (t.reference = C(e.reference)), t;
}
function m(e) {
  if (!e)
    return console.warn("Cannot parse empty json inside parseSelectedOption"), {};
  const t = {};
  return e.name && (t.name = e.name), e.value && (t.value = e.value), t;
}
function h(e) {
  var i;
  if (!e)
    return console.warn("Cannot parse empty json inside parseVariant"), {};
  const t = {};
  return e.id && (t.id = e.id), e.title && (t.title = e.title), e.price && (t.price = e.price), e.compareAtPrice && (t.compareAtPrice = e.compareAtPrice), (i = e.product) != null && i.id && (t.productId = e.product.id), e.image && (t.image = l(e.image)), e.metafields && (t.metafields = e.metafields.map(f)), e.selectedOptions && (t.selectedOptions = e.selectedOptions.map(m)), t;
}
function k(e) {
  if (!e)
    return console.warn("Cannot parse empty json inside parseCollections"), {};
  const t = {};
  return e.id && (t.id = e.id), e.title && (t.title = e.title), e.description && (t.description = e.description), t;
}
function I(e) {
  if (!e)
    return console.warn("Cannot parse empty json inside parseOption"), {};
  const t = {};
  return e.id && (t.id = e.id), e.name && (t.name = e.name), e.values && (t.values = e.values), t;
}
function d(e) {
  if (!e)
    return console.warn("Cannot parse empty json inside parseProduct"), {};
  const t = {};
  return e.id && (t.id = e.id), e.description && (t.description = e.description), e.descriptionHtml && (t.descriptionHtml = e.descriptionHtml), e.handle && (t.handle = e.handle), e.title && (t.title = e.title), e.priceRange && (t.priceRange = e.priceRange), e.compareAtPriceRange && (t.compareAtPriceRange = e.compareAtPriceRange), e.options && (t.options = e.options.map(I)), e.images && (t.images = e.images.nodes.map(l)), e.featuredImage && (t.featuredImage = e.featuredImage), e.metafields && (t.metafields = e.metafields.map(f)), e.variants && (t.variants = e.variants.nodes.map(h)), e.collections && (t.collections = e.collections.nodes.map(k)), e.tags && (t.tags = e.tags), t;
}
function v(e) {
  if (!e)
    return console.warn("Cannot parse empty json inside parseProductVariant"), {};
  const t = {};
  return e.id && (t.id = e.id), e.price && (t.price = e.price), e.product && (t.product = d(e.product)), e.image && (t.image = l(e.image)), e.selectedOptions && (t.selectedOptions = e.selectedOptions.map(m)), e.sku && (t.sku = e.sku), t;
}
function $(e) {
  if (!e)
    return console.warn("Cannot parse empty json inside parseLine"), {};
  const t = {};
  return e.id && (t.id = e.id), e.attributes && (t.attributes = e.attributes), e.quantity !== void 0 && (t.quantity = e.quantity), e.merchandise && (t.merchandise = v(e.merchandise)), t;
}
function u(e) {
  if (!e)
    return console.warn("Cannot parse empty json inside parseCollection"), {};
  const t = {};
  return e.id && (t.id = e.id), e.description && (t.description = e.description), e.title && (t.title = e.title), e.image && (t.image = l(e.image)), e.metafields && (t.metafields = e.metafields.map(f)), e.products && (t.products = e.products.nodes.map(d)), t;
}
function o(e) {
  var i, a;
  if (!e)
    return console.warn("Cannot parse empty json inside parseCart"), {};
  const t = {};
  return e.id && (t.id = e.id), e.checkoutUrl && (t.checkoutUrl = e.checkoutUrl), ((i = e.cost) == null ? void 0 : i.subtotalAmount) !== void 0 && (t.subtotal = (a = e.cost) == null ? void 0 : a.subtotalAmount), e.totalQuantity !== void 0 && (t.totalQuantity = e.totalQuantity), e.lines && (t.lines = e.lines.nodes.map($)), t;
}
class w {
  constructor(t, i) {
    c(this, "locale");
    c(this, "makeRequest");
    c(this, "checkoutUrl");
    c(this, "lines", []);
    c(this, "currency", "USD");
    c(this, "subtotal");
    c(this, "totalQuantity", 0);
    // all cart queries and mutation should get back the same properties
    c(this, "sharedGetCartProperties", `
        checkoutUrl
        id
        totalQuantity
        cost {
            subtotalAmount {
                amount
                currencyCode
            }
        }
        lines(first: 100) {
            nodes {
                id
                quantity
                merchandise {
                    ... on ProductVariant {
                        id
                        sku
                        price {
                            amount
                            currencyCode
                        }
                        selectedOptions {
                            name
                            value
                        }
                        product {
                            id
                            title
                            tags
                            handle
                            collections(first: 100) {
                                nodes {
                                    id
                                    title
                                }
                            }
                        }
                        image {
                            url
                        }
                    }
                }
                attributes {
                    key
                    value
                }
            }
        }`);
    this.locale = i, this.makeRequest = t;
  }
  get localeDirective() {
    return `@inContext(language: ${this.locale})`;
  }
  getCartId() {
    const t = localStorage.getItem("cartId");
    return t || (this.resetCart(), null);
  }
  resetCart() {
    delete this.checkoutUrl, this.lines = [], delete this.subtotal, this.totalQuantity = 0, localStorage.removeItem("cartId");
  }
  setCartValues(t) {
    var i, a;
    t.checkoutUrl && (this.checkoutUrl = t.checkoutUrl), t.lines && (this.lines = t.lines), t.subtotal && (this.subtotal = t.subtotal), ((i = t.subtotal) == null ? void 0 : i.currencyCode) !== "XXX" && (this.currency = ((a = t.subtotal) == null ? void 0 : a.currencyCode) ?? "USD"), t.totalQuantity && (this.totalQuantity = t.totalQuantity);
  }
  async createCart() {
    const t = `mutation {
            cartCreate(input: {}) {
                cart {
                    ${this.sharedGetCartProperties}
                }
            }
        }`, i = await this.makeRequest(t), a = o(i.data.cartCreate.cart);
    return localStorage.setItem("cartId", a.id), this.setCartValues(a), a;
  }
  async refresh() {
    const t = this.getCartId();
    if (!t)
      return null;
    const i = `query getCart($cartId: ID!) @inContext(language: EN) {
            cart(id: $cartId) {
                ${this.sharedGetCartProperties}
            }
        }`, a = await this.makeRequest(i, {
      cartId: t
    });
    if (!a.data.cart)
      return this.resetCart(), null;
    const r = o(a.data.cart);
    return this.setCartValues(r), r;
  }
  async addItems(t) {
    let i = this.getCartId();
    i || (await this.createCart(), i = this.getCartId());
    const a = `mutation add($cartId: ID!, $lines: [CartLineInput!]!) {
            cartLinesAdd(cartId: $cartId, lines: $lines) {
                cart {
                    ${this.sharedGetCartProperties}
                }
            }
        }`, r = await this.makeRequest(a, {
      cartId: i,
      lines: t
    }), n = o(r.data.cartLinesAdd.cart);
    return this.setCartValues(n), n;
  }
  async removeItem(t) {
    const i = this.getCartId();
    if (!i)
      throw new Error("No cart is available");
    const a = `mutation remove($cartId: ID!, $lineIds: [ID!]!) {
            cartLinesRemove(cartId: $cartId, lineIds: $lineIds) {
                cart {
                    ${this.sharedGetCartProperties}
                }
            }
        }`, r = await this.makeRequest(a, {
      cartId: i,
      lineIds: t
    }), n = o(r.data.cartLinesRemove.cart);
    return this.setCartValues(n), n;
  }
  async updateItems(t) {
    const i = this.getCartId();
    if (!i)
      throw new Error("No cart is available");
    const a = `mutation cartLinesUpdate($cartId: ID!, $lines: [CartLineUpdateInput!]!) {
            cartLinesUpdate(cartId: $cartId, lines: $lines) {
                cart {
                    ${this.sharedGetCartProperties}
                }
            }
        }`, r = await this.makeRequest(a, {
      cartId: i,
      lines: t
    }), n = o(r.data.cartLinesUpdate.cart);
    return this.setCartValues(n), n;
  }
  async setCountryCode(t) {
    let i = this.getCartId();
    i || (await this.createCart(), i = this.getCartId());
    const a = `mutation cartBuyerIdentityUpdate($buyerIdentity: CartBuyerIdentityInput!, $cartId: ID!) {
            cartBuyerIdentityUpdate(buyerIdentity: $buyerIdentity, cartId: $cartId)  {
                cart {
                  ${this.sharedGetCartProperties}
                }
                userErrors {
                      field
                      message
                    }
                }
            }`, r = {
      countryCode: t
    }, n = await this.makeRequest(a, {
      cartId: i,
      buyerIdentity: r
    }), s = o(n.data.cartBuyerIdentityUpdate.cart);
    return this.setCartValues(s), s;
  }
}
class P {
  constructor(t, i = "EN", a = "US") {
    c(this, "locale");
    c(this, "countryCode");
    c(this, "makeRequest");
    this.locale = i, this.countryCode = a, this.makeRequest = t;
  }
  get localeDirective() {
    return `@inContext(language: ${this.locale}, country: ${this.countryCode})`;
  }
  // TODO: Investigate generic 'getObject' method that takes a full gid://
  // string, identifies the type of the result, and returns it along with a
  // selection of common fields. Useful if you have a Product or a Variant and
  // don't necessarily know which it is in advance.
  /**
   * Get storefront pricing information for a product id. Useful for fetching
   * packs, bundles and standalone titles.
   *
   * Used in jbg-web
   */
  async getStorefrontPricing(t) {
    const i = `query getProductBy($id: ID!) ${this.localeDirective} {
            product(id: $id) {
                title
                variants(first: 1) {
                    nodes {
                        id
                        title
                        price {
                            amount
                        }
                    }
                }
                metafields(
                    identifiers: [{ namespace: "custom", key: "storefront_pricing" }]
                ) {
                    key
                        reference {
                        ... on Metaobject {
                            fields {
                                key
                                value
                            }
                        }
                    }
                }
                priceRange {
                    minVariantPrice {
                        amount
                        currencyCode
                    }
                }
                compareAtPriceRange {
                    maxVariantPrice {
                        amount
                        currencyCode
                    }
                }
            }
        }`, a = await this.makeRequest(i, {
      id: `gid://shopify/Product/${t}`
    });
    return d(a.data.product);
  }
  /**
   * Gets a list of Products in a Collection
   *
   * Used on jackboxgames.com to show products for sale
   */
  async getCollectionProducts(t) {
    const i = `query ${this.localeDirective} {
            collection(id: "gid://shopify/Collection/${t}") {
                products(first: 100) {
                    nodes {
                        handle
                        title
                        options {
                            id
                            name
                            values
                        }
                        priceRange {
                            minVariantPrice {
                                amount
                                currencyCode
                            }
                            maxVariantPrice {
                                amount
                                currencyCode
                            }
                        }
                        compareAtPriceRange {
                            minVariantPrice {
                                amount
                                currencyCode
                            }
                            maxVariantPrice {
                                amount
                                currencyCode
                            }
                        }
                        featuredImage {
                            url
                            width
                            height
                        }
                        variants(first: 100) {
                            nodes {
                                id
                                title
                                image {
                                    url
                                    height
                                    width
                                }
                                selectedOptions {
                                    name
                                    value
                                }
                                price {
                                    amount
                                    currencyCode
                                }
                                compareAtPrice {
                                    amount
                                    currencyCode
                                }
                            }
                        }
                    }
                }
            }
        }`, a = await this.makeRequest(i);
    return u(a.data.collection);
  }
  /**
   * Gets details for a specific product
   *
   * Used on jackboxgames.com to show products for sale
   */
  async getProduct(t, i) {
    let a = "";
    i && (a = `metafields(identifiers: [
                ${i.map((p) => `{ namespace: "${p.namespace}", key: "${p.key}"}`).join(",")}
            ]) {
                    key
                        reference {
                        ... on Metaobject {
                            fields {
                                key
                                value
                            }
                        }
                    }
                }
            `);
    const r = `query ${this.localeDirective} {
            product(handle: "${t}") {
                id
                handle
                title
                descriptionHtml
                description
                images(first: 20) {
                    nodes {
                        id
                        url
                        width
                        height
                        altText
                    }
                }
                options {
                    id
                    name
                    values
                }
                ${a}
                priceRange {
                    minVariantPrice {
                        amount
                        currencyCode
                    }
                    maxVariantPrice {
                        amount
                        currencyCode
                    }
                }
                compareAtPriceRange {
                    minVariantPrice {
                        amount
                        currencyCode
                    }
                    maxVariantPrice {
                        amount
                        currencyCode
                    }
                }
                featuredImage {
                    url
                    width
                    height
                }                    
                variants(first: 100) {
                    nodes {
                        id
                        title
                        selectedOptions {
                            name
                            value
                        }
                        image {
                            url
                            height
                            width
                        }
                        price {
                            amount
                            currencyCode
                        }
                        compareAtPrice {
                            amount
                            currencyCode
                        }
                    }
                }
            }
        }`, n = await this.makeRequest(r);
    return d(n.data.product);
  }
  /**
   * Gets a the collection of products used in TKO 2 shopping ui
   *
   * Used in TKO2 galleries
   */
  async getTeeKO2Products() {
    const t = `query ${this.localeDirective} {
            collection(id: "gid://shopify/Collection/269996851334") {
                products(first: 100) {
                    nodes {
                        handle
                        metafields(identifiers: [
                            { namespace: "custom", key: "teeko2_metadata" },
                            { namespace: "custom", key: "product_type" }
                        ]) {
                            key
                            value
                            reference {
                                ... on Metaobject {
                                    fields {
                                        key
                                        value
                                    }
                                }
                            }
                        }
                        variants(first: 100) {
                            nodes {
                                id
                                title
                                price {
                                    amount
                                    currencyCode
                                }
                                metafields(
                                    identifiers: [
                                        { namespace: "gooten", key: "layout_image" }
                                    ]
                                ) {
                                    key
                                    value
                                }
                            }
                        }
                    }
                }
            }
        }`;
    console.log("a");
    const i = await this.makeRequest(t);
    return console.log(i), u(i.data.collection);
  }
  /**
   * Gets a the collection of products used in TKO shopping ui
   *
   * Used in new TKO galleries
   */
  async getTeeKO1Products() {
    const t = `query ${this.localeDirective} {
            collection(id: "gid://shopify/Collection/279592632454") {
                products(first: 100) {
                    nodes {
                        handle
                        metafields(identifiers: [
                            { namespace: "custom", key: "teeko2_metadata" },
                            { namespace: "custom", key: "product_type" }
                        ]) {
                            key
                            value
                            reference {
                                ... on Metaobject {
                                    fields {
                                        key
                                        value
                                    }
                                }
                            }
                        }
                        variants(first: 100) {
                            nodes {
                                id
                                title
                                price {
                                    amount
                                    currencyCode
                                }
                                metafields(
                                    identifiers: [
                                        { namespace: "gooten", key: "layout_image" }
                                    ]
                                ) {
                                    key
                                    value
                                }
                            }
                        }
                    }
                }
            }
        }`, i = await this.makeRequest(t);
    return u(i.data.collection);
  }
  /**
   * Gets a product and populates any metafields.
   *
   * Used in TKO2 `merch` renderer
   */
  async getProductWithMetafields(t, i) {
    const a = `query productWithMetafields($id: ID!, $metafields: [HasMetafieldsIdentifier!]!) ${this.localeDirective} {
            node(id: $id) {
                ... on Product {
                    metafields(identifiers: $metafields) {
                        key
                        value
                        reference {
                        ... on Metaobject {
                                fields {
                                    key
                                    value
                                }
                            }
                        }
                    }
                }
            }
        }`, r = await this.makeRequest(a, {
      id: `gid://shopify/Product/${t}`,
      metafields: i
    });
    return d(r.data.node);
  }
  /**
   * Gets a product variant and populates any metafields.
   *
   * Used in TKO2 `merch` renderer
   */
  async getVariantWithMetafields(t, i) {
    const a = `query variantWithMetafields($id: ID!, $metafields: [HasMetafieldsIdentifier!]!) ${this.localeDirective} {
            node(id: $id) {
                ... on ProductVariant {
                    product {
                        id
                    }
                    metafields(identifiers: $metafields) {
                        key
                        value
                        reference {
                        ... on Metaobject {
                                fields {
                                    key
                                    value
                                }
                            }
                        }
                    }
                }
            }
        }`, r = await this.makeRequest(a, {
      id: `gid://shopify/ProductVariant/${t}`,
      metafields: i
    });
    return h(r.data.node);
  }
}
class R {
  constructor(t) {
    c(this, "shopUrl");
    c(this, "apiToken");
    c(this, "isDebug");
    c(this, "locale");
    c(this, "countryCode");
    c(this, "query");
    c(this, "cart");
    this.shopUrl = `https://${t.shopName}.myshopify.com/api/2025-04/graphql.json`, this.apiToken = t.apiToken, this.locale = this.parseLocale(t.locale), this.countryCode = t.countryCode || "US", this.isDebug = t.debug ?? !1, this.query = new P(this.makeRequest.bind(this), this.locale, this.countryCode), t.enableCart && (this.cart = new w(this.makeRequest.bind(this), this.locale));
  }
  setLocale(t) {
    this.locale = this.parseLocale(t);
  }
  /**
   * Shopify expects ISO 639-1 language codes so this converts
   * controller language codes to valid ISO codes either from a
   * map or by simply uppercasing them.
   */
  parseLocale(t) {
    return t ? {
      "es-XL": "ES",
      "pt-BR": "PT_BR",
      "pt-br": "PT_BR"
    }[t] || t.toLocaleUpperCase() : "EN";
  }
  // Request
  async makeRequest(t, i = {}) {
    const a = {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-Shopify-Storefront-Access-Token": this.apiToken
      }),
      body: JSON.stringify({ query: t, variables: i })
    }, r = await fetch(this.shopUrl, a);
    if (!r.ok)
      throw console.error(r), new Error("Shopify response is not okay");
    let n;
    try {
      n = await r.json();
    } catch (s) {
      throw new Error("Failed to parse Shopify response as JSON", { cause: s });
    }
    if (this.isDebug && console.log(n), n.errors)
      throw console.error(n.errors), new Error("Errors returned in Shopify response");
    return n;
  }
  // Static helpers
  static getMetaValue(t, i) {
    const a = i.split(".");
    if (a.length > 2) {
      console.warn("getMetaValue only supports 1 level of reference fields");
      return;
    }
    const r = t.find((s) => s.key === a[0]);
    if (!r) {
      console.warn(`getMetaValue could find a field with key ${a[0]}`);
      return;
    }
    if (a.length === 1) {
      if (!r.value) {
        console.warn(`getMetaValue could find a value for key ${a[0]}`);
        return;
      }
      return r.value;
    }
    if (!r.reference) {
      console.warn(`getMetaValue could find reference for key ${a[0]}`);
      return;
    }
    if (!r.reference.fields) {
      console.warn(`getMetaValue could find a fields for key ${a[0]}`);
      return;
    }
    const n = r.reference.fields.find((s) => s.key === a[1]);
    if (!n) {
      console.warn(`getMetaValue could find a field for key ${a[1]}`);
      return;
    }
    if (!n.value) {
      console.warn(`getMetaValue could find a value for key ${a[1]}`);
      return;
    }
    return n.value;
  }
}
export {
  R as default
};
